import { applyWhiteLabelThemeToDocument, createWhiteLabelTheme } from "../shared/theme";

export const whiteLabelTheme = createWhiteLabelTheme({
  font: {
    googleFontUrl:
      "https://fonts.googleapis.com/css2?family=Google+Sans:ital,opsz,wght@0,17..18,400..700;1,17..18,400..700&display=swap",
  },
  componentClasses: {
    button: {
      base: "",
      solid: "",
      solidBgColor: "",
      solidTextColor: "",
      outline: "",
      outlineBorderColor: "",
      outlineTextColor: "",
    },
    card: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedBgColor: "",
      softBgColor: "",
      titleColor: "",
      subtitleColor: "",
    },
    dashboardCard: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedTextColor: "",
      accentBgColor: "",
      accentTextColor: "",
    },
    input: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      labelColor: "",
      focusBorderColor: "",
      focusRingColor: "",
      errorBorderColor: "",
      errorTextColor: "",
    },
    select: {
      trigger: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      menu: "",
      option: "",
      optionHoverBgColor: "",
    },
    header: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      phoneTextColor: "",
      menuIconColor: "",
      loginButton: "",
      loginButtonBgColor: "",
      loginButtonTextColor: "",
    },
    sidebar: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      activeItem: "",
      activeItemBgColor: "bg-theme-primary-soft",
      activeItemTextColor: "text-theme-primary",
      inactiveItem: "",
      inactiveItemTextColor: "",
      toggleButton: "",
      toggleButtonBgColor: "",
      toggleIconColor: "",
    },
    loginFormBackground: {
      bgColor: "",
    },
    progressIndicator: {
      wrapperClassName: "bg-gradientbar",
      labelClassName: "!text-white",
    },
  },
  colors: {
    canvas: "#F8FAFC",
    canvasMuted: "#F1F5F9",
    surface: "#FFFFFF",
    surfaceSubtle: "#F9FAFB",
    surfaceMuted: "#F3F4F6",
    surfaceSoft: "#f6f7f9",

    primary: "#3078fa",
    primaryAlt: "#3B82F6",
    primaryHover: "#1D4ED8",
    primarySoft: "#DBEAFE",

    // accent: "#E9D5FF",
    // accentHover: "#D8B4FE",
    // accentStrong: "#C084FC",
    // accentSoft: "#F5F3FF",
    accent: "#93C5FD",
    accentHover: "#7DD3FC",
    accentStrong: "#60A5FA",
    accentSoft: "#F0F9FF",

    text: "#111827",
    textMuted: "#4B5563",
    textSoft: "#6B7280",
    textPlaceholder: "#9CA3AF",
    textInverse: "#FFFFFF",

    border: "#E5E7EB",
    borderStrong: "#D1D5DB",
    borderLight: "#F3F4F6",

    overlay: "rgba(0, 0, 0, 0.45)",

    success: "#2563EB",
    successSoft: "#EFF6FF",
    successSoftAlt: "#EFF6FF",
    successPale: "#F0F9FF",
    successBright: "#3B82F6",
    successHero: "#60A5FA",
    successStrong: "#1D4ED8",
    successDeep: "#1E3A8A",
    successBorderSoft: "#BFDBFE",
    successBrightSoft: "#DBEAFE",
    successTextStrong: "#1D4ED8",

    warning: "#F59E0B",
    warningSoft: "#FFFBEB",
    warningBright: "#FACC15",
    warningPale: "#FEFCE8",
    warningBrightSoft: "#FEF9C3",
    warningTextStrong: "#B45309",
    warningAlt: "#FB923C",
    warningHero: "#FBBF24",

    danger: "#DC2626",
    dangerSoft: "#FEF2F2",
    dangerBright: "#EF4444",
    dangerHero: "#F87171",
    dangerBrightSoft: "#FEE2E2",
    dangerTextStrong: "#991B1B",

    info: "#0EA5E9",
    infoSoft: "#F0F9FF",
    infoBright: "#38BDF8",
    infoSoftAlt: "#E0F2FE",
    infoTextStrong: "#0369A1",
    infoAccent: "#0284C7",

    purpleSoft: "#F5F3FF",
    purplePale: "#FAF5FF",
    purpleStrong: "#7C3AED",
    purpleText: "#8B5CF6",

    orangeSoft: "#FFF7ED",
    orangeText: "#EA580C",

    shadow: "rgba(0, 0, 0, 0.02)",
  },

  gradients: {
    primary: {
      start: "#51A3FF",
      end: "#014b9c",
    },
    accent: {
      start: "#E3F2FD",
      end: "#42A5F5",
    },
    step: {
      start: "#60A5FA",
      end: "#2563EB",
    },
  },
});

export function applyWhiteLabelTheme() {
  applyWhiteLabelThemeToDocument(whiteLabelTheme);
}
